import React, { Component } from 'react';
import { Grid as G, Header as H } from 'semantic-ui-react';
import styled from 'styled-components';

import screen from '../../assets/screen.jpg';
import alert from '../../assets/alert.png';
import funnel from '../../assets/funnel.png';
import graph from '../../assets/graph.png';

class Process extends Component {
  constructor(props) {
    super(props);
    this.state = {
      waypoint: true
    };
  }

  setWaypoint = () => {
    if (window.innerWidth <= 767) {
      this.setState({ waypoint: false });
    } else {
      this.setState({ waypoint: true });
    }
  };

  componentDidMount() {
    this.setWaypoint();
    window.addEventListener('resize', () => {
      this.setWaypoint();
    });
  }

  render() {
    const { waypoint } = this.state;
    const assetCollumnStyle = { display: 'flex', justifyContent: 'center' };
    const textColumnStyle = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    };
    const headerTextAlign = position => (waypoint ? position : 'center');
    return (
      <Container id="container-process">
        <Title active={this.state.rowTwo}>{this.props.ProcessTitle}</Title>
        <ContentContainer>
          {/**/}

          <Grid columns={2} stackable padded style={{ height: '50vh!important' }}>
            <G.Column padded style={{ ...assetCollumnStyle, order: waypoint ? 0 : 1 }}>
              <Asset>
                <Image src={funnel} style={{ boxShadow: '0 10px 50px black', borderRadius: 5 }} />
              </Asset>
            </G.Column>
            <G.Column padded style={textColumnStyle}>
              <Header textAlign={headerTextAlign('left')} as="h2">
                {this.props.Process1.title}
              </Header>
              <Paragraph textAlign={headerTextAlign('left')}>{this.props.Process1.text}</Paragraph>
            </G.Column>
          </Grid>

          {/**/}

          <Grid columns={2} stackable padded style={{ height: '50vh!important' }}>
            <G.Column padded style={textColumnStyle}>
              <Header as="h2" textAlign={headerTextAlign('right')}>
                {this.props.Process2.title}
              </Header>
              <Paragraph textAlign={headerTextAlign('right')}>{this.props.Process2.text}</Paragraph>
            </G.Column>
            <G.Column padded style={assetCollumnStyle}>
              <Asset>
                <Image src={alert} style={{ boxShadow: '0 10px 50px black', borderRadius: 5 }} />
              </Asset>
            </G.Column>
          </Grid>

          {/**/}
          <Grid columns={2} stackable padded style={{ height: '50vh!important' }}>
            <G.Column padded style={{ ...assetCollumnStyle, order: waypoint ? 0 : 1 }}>
              <Asset>
                <Image src={graph} style={{ boxShadow: '0 10px 50px black', borderRadius: 5 }} />
              </Asset>
            </G.Column>
            <G.Column padded style={textColumnStyle}>
              <Header as="h2" textAlign={headerTextAlign('left')}>
                {this.props.Process3.title}
              </Header>
              <Paragraph textAlign={headerTextAlign('left')}>{this.props.Process3.text}</Paragraph>
            </G.Column>
          </Grid>
          {/**/}
          <Grid columns={2} stackable padded style={{ height: '50vh!important' }}>
            <G.Column padded style={textColumnStyle}>
              <Header as="h2" textAlign={headerTextAlign('right')}>
                {this.props.Process4.title}
              </Header>
              <Paragraph textAlign={headerTextAlign('right')}>{this.props.Process4.text}</Paragraph>
            </G.Column>
            <G.Column padded style={assetCollumnStyle}>
              <Asset>
                <Image src={screen} />
              </Asset>
            </G.Column>
          </Grid>
        </ContentContainer>
      </Container>
    );
  }
}

export default Process;

const Container = styled.div`
  width: 100vw;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  background: white;
  color: #4babc0;
`;

const Grid = styled(G)`
  &.column.grid {
    /* min-height: 60vh !important; */
    padding: 2rem 0 !important;
  }
`;

const Title = styled.div`
  width: 100%;

  margin-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  line-height: 3rem;
  font-weight: 700;
  /* padding: 3rem 0; */
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  position: relative;
`;

const Asset = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  @media (max-width: 500px) {
    margin: 0 auto;
    width: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  max-width: 500px;
  max-height: 300px;
  @media (max-width: 500px) {
    width: 90%;
    margin: 0 auto;
  }
`;

const Header = styled(H)`
  width: 100%;
  padding: 0.5rem;
  font-size: 1.8rem !important;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  margin-bottom: 1.5rem;
  margin-top: 0.5rem;
  color: #4babc0 !important;
  /* @media (max-width: 1270px) {
    font-size: 1.7px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
  @media (max-width: 1150px) {
    font-size: 25px;
  }
  @media (max-width: 800px) {
    // font-size: 20px;
    margin-top: 1rem;
    margin-bottom: 1rem;
  } */
`;

const Paragraph = styled.p`
  color: #333 !important;
  font-size: 20px;
  text-align: ${props => props.textAlign};
`;



// WEBPACK FOOTER //
// ./src/components/Process/index.js